export default __webpack_public_path__ + "static/6-4e2a4b25066665f79800b99cae89ae82.png";